// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"10bd98e3","177":"65ac12ef","288":"5e405ccf","480":"676699e0","972":"446a8777"}[chunkId] + ".chunk.js";
};